import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef } from "react";

import { ArrowSquareOutIcon } from "@phosphor-icons/react/dist/csr/ArrowSquareOut";
import { DOCUMENTATION } from "../../constants/externalLinks";

const ButtonGroup = styled("div")({
  button: {
    marginRight: "10px",
    "&:last-child": {
      marginRight: "inherit",
    },
  },
});

const BlankButton = styled(Button)({
  color: "initial",
  background: "initial",
});

const DocsButton = forwardRef<HTMLAnchorElement | null>((_, ref) => (
  <Button
    ref={ref}
    variant="text"
    href={DOCUMENTATION}
    target="_blank"
    rel="noreferrer"
    endIcon={<ArrowSquareOutIcon />}
  >
    Docs
  </Button>
));
DocsButton.displayName = "DocsButton";

const StatefulButton = forwardRef<HTMLButtonElement, ButtonProps & { loading: boolean }>((props, ref) => {
  const { loading = false, children, ...buttonProps } = props;

  buttonProps.disabled = loading || buttonProps.disabled;
  if (loading) {
    buttonProps.startIcon = (
      <CircularProgress
        size="0.8em"
        sx={(theme) => ({
          color: props.color === "secondary" ? theme.palette.secondary.main : theme.palette.primary.main,
        })}
      />
    );
  }

  return (
    <Button ref={ref} {...buttonProps}>
      {children}
    </Button>
  );
});
StatefulButton.displayName = "StatefulButton";

export { BlankButton, ButtonGroup, DocsButton, StatefulButton };
